<template>
  <div
    @mouseenter="isShowNotificationsMenu = true"
    @mouseleave="isShowNotificationsMenu = false"
  >
    <v-divider
      v-if="index > 0 && index"
      inset
    />
    <v-list-item
      dense
      style="position: relative; overflow-x: hidden"
      @click="handleClick(notification)"
      @click.stop="notification.is_read === 0 ? changeNotificationReadStatus(1) : null"
    >
      <v-list-item-avatar>
        <v-icon
          v-if="notification.notification_module_id === 1"
          dark
          large
          color="primary"
        >mdi-whatsapp</v-icon>
        <v-icon
          v-else
          dark
          color="primary"
        >mdi-cog</v-icon>
      </v-list-item-avatar>

      <v-list-item-content style="width: 100%;">
        <v-list-item-title v-html="parsedTitle.html" />
        <v-list-item-subtitle
          class="caption"
          v-html="parsedMessage.html"
        />
      </v-list-item-content>
      <v-list-item-action class="align-self-end d-flex">
        <div style="width: 100px">
          <v-list-item-action-text
            :color="notification.is_read === 0 ? 'blue' : ''"
            v-text="formatDate(notification.created_at)"
          />
          <div
            style="display: flex; flex-direction: row;"
            class="mr-2"
          >
            <v-spacer />
            <v-icon
              v-show="notification.is_read === 0"
              size="16"
              color="blue"
            >mdi-circle</v-icon>
          </div>
        </div>
      </v-list-item-action>
      <div style="margin-left:12px; position: absolute; right: 0; top: 0;">
        <ToolbarNotificationsMenu
          :is-show="isShowNotificationsMenu"
          :notification="notification"
          @markAsRead="changeNotificationReadStatus($event)"
        />
      </div>
    </v-list-item>
  </div>
  
</template>

<script setup>
import { defineProps, defineEmits, ref, getCurrentInstance, watch } from 'vue'
import { RequestError } from '@/services/errorHandler.service'
import CustomException from '@/services/customException'
import BackendApi from '@/services/backend.service'
import ToolbarNotificationsMenu from './ToolbarNotificationsMenu.vue'
import { parseMarkdown } from '@/utils/markdownParser'

const props = defineProps({
  notification: Object,
  index: Number
})

const emit = defineEmits(['setIsReadById', 'openDialog', 'router'])

const isShowNotificationsMenu = ref(false)
const parsedMessage = ref({ html: '', links: [] })
const parsedTitle = ref({ html: '', links: [] })
const changeNotificationReadStatus = async (newReadStatus) => {
  try {
    const response = await BackendApi.post('/setNotificationIsReadStatus', { user_notification_id: props.notification.user_notification_id, newReadStatus })

    if (!response?.data?.success) {
      throw new RequestError(response)
    }

    emit('setIsReadById', { user_notification_id: props.notification.user_notification_id, newReadStatus })
  } catch (error) {
    CustomException.handleError({ rootMethod: 'getServices', error }, this)
  }
}

const formatDate = (dateString) => {
  const date = new Date(dateString)
  const now = new Date()
  const diffInSeconds = Math.floor((now - date) / 1000)
  const timeUnits = [
    { limit: 60, divisor: 1, singular: 'segundo', plural: 'segundos' },
    { limit: 3600, divisor: 60, singular: 'minuto', plural: 'minutos' },
    { limit: 86400, divisor: 3600, singular: 'hora', plural: 'horas' },
    { limit: 604800, divisor: 86400, singular: 'día', plural: 'días' },
    { limit: 2592000, divisor: 604800, singular: 'semana', plural: 'semanas' }
  ]
  for (const unit of timeUnits) {
    if (diffInSeconds < unit.limit) {
      const value = Math.floor(diffInSeconds / unit.divisor)
      const label = value > 1 ? unit.plural : unit.singular
      return `hace ${value} ${label}`
    }
  }
  return date.toLocaleDateString('es-ES')
}

const instance = getCurrentInstance()

const handleClick = (notification) => {
  emit('openDialog', notification)
}

watch(() => props.notification, (newVal) => {
  if (!newVal?.message) return
  parsedMessage.value = parseMarkdown(newVal.message)
}, { immediate: true })
watch(() => props.notification, (newVal) => {
  if (!newVal) return
  parsedMessage.value = parseMarkdown(newVal.message)
  parsedTitle.value = parseMarkdown(newVal.title || '')
}, { immediate: true })
</script>